/**
 * The branded agent-workflow chip, extracted verbatim from ChatHeader
 * (Unit 5, insurescope-7149k.2.2.3; contract: the 5.DESIGN brief on
 * insurescope-7149k.2.2.1). One chip for every surface that names an
 * agent — chat header and workspace conversation rows (R8); never
 * re-style locally. Renders nothing for empty/whitespace names (never an
 * empty pill); long names truncate at max-w-48 with the full name on the
 * native title. The `agent-chip` testid is pinned by existing suites.
 *
 * Known: text-primary on bg-primary/[0.08] fails contrast in dark mode —
 * a repo-wide `--primary` token defect (insurescope-z6oc4), inherited
 * here deliberately so the badge keeps parity and picks up the token fix.
 */
export interface AgentBadgeProps {
    /** Agent workflow name; empty/whitespace renders nothing. */
    agent: string;
}

export function AgentBadge({ agent }: AgentBadgeProps) {
    if (!agent.trim()) return null;

    return (
        <span
            className="bg-primary/[0.08] text-primary inline-flex max-w-48 shrink-0 items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-medium"
            data-testid="agent-chip"
            title={agent}
        >
            <span
                aria-hidden="true"
                className="bg-primary/70 size-1.5 shrink-0 rounded-full"
            />
            <span className="truncate">{agent}</span>
        </span>
    );
}
